var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Affiliate Marketing Course")]),_c('p',[_vm._v("Learn how to become a successful affiliate marketer with our comprehensive course.")])])
}]

export { render, staticRenderFns }